/**
 * Derives 1–2 display initials from a person's name.
 * Handles CJK, accents, emoji-adjacent names, and empty input.
 */
export function getUserInitials(name?: string | null): string {
  const trimmed = name?.trim();
  if (!trimmed) return "?";

  const parts = trimmed.split(/\s+/).filter(Boolean);
  const pickLetter = (segment: string): string => {
    for (const char of segment) {
      if (/\p{L}/u.test(char)) return char.toUpperCase();
    }
    return segment[0]?.toUpperCase() ?? "?";
  };

  if (parts.length >= 2) {
    return pickLetter(parts[0]) + pickLetter(parts[parts.length - 1]);
  }

  const word = parts[0];
  const letters = [...word].filter((char) => /\p{L}/u.test(char));
  if (letters.length >= 2) {
    return (letters[0] + letters[1]).toUpperCase();
  }

  return pickLetter(word);
}
